import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Status({ status }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.status}>
      <div
        className={styles.square}
        style={{ backgroundColor: status.color }}
      />
      <span className={styles.paragraph}>
        {t(`taskStatuses.${status.label}`, status.label)}
      </span>
    </div>
  );
}

export { Status };
